module.exports = __webpack_public_path__ + "static/favicon-f3e99622b72adefe3df8dfc859a61e93.png";